import {all, call, put, takeEvery} from 'redux-saga/effects'
import {
  ProvincesActionTypes, deleteError, deleteSuccess, fetchError, fetchSuccess, createError, createSuccess,
  updateSuccess, updateError, fetchItemSuccess, fetchItemError
} from '@actions/province';
import {updateSuccess as updateCurrentProvince} from '@actions/auth';
import provinceApi from '@api/province';
import {ReduxAction} from "@actions/index";


function* handleFetch({payload}: ReduxAction) {
  try {
    const res = yield call(provinceApi.getList, payload);
    yield put(fetchSuccess(res))
  } catch (err) {
    yield put(fetchError(err))
  }
}


function* handleDelete({payload}: ReduxAction) {
  try {
    yield call(provinceApi.delete, payload);
    yield put(deleteSuccess(payload.params));
  } catch (err) {
    yield put(deleteError(err))
  }
}


function* handleCreate({payload}: ReduxAction) {
  try {
    const {data} = yield call(provinceApi.create, payload);
    payload.onSuccessCallback && payload.onSuccessCallback(data);
    yield put(createSuccess(data))
  } catch (err) {
    yield put(createError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}

function* handleUpdate({payload}: ReduxAction) {
  try {
    const {data} = yield call(provinceApi.update, payload);
    payload.onSuccessCallback && payload.onSuccessCallback();
    yield put(updateSuccess(data));
    // For updating current province info in header :
    yield put(updateCurrentProvince(data));
  } catch (err) {
    yield put(updateError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}

function* handleFetchItem({payload}: ReduxAction) {
  try {
    const {data} = yield call(provinceApi.getItem, payload);
    yield put(fetchItemSuccess(data))
  } catch (err) {
    yield put(fetchItemError(err))
  }
}


// We can also use `fork()` here to split our saga into multiple watchers.
function* provincesSaga() {
  yield all([
    yield takeEvery(ProvincesActionTypes.FETCH_REQUEST, handleFetch),
    yield takeEvery(ProvincesActionTypes.DELETE_REQUEST, handleDelete),
    yield takeEvery(ProvincesActionTypes.CREATE_REQUEST, handleCreate),
    yield takeEvery(ProvincesActionTypes.UPDATE_REQUEST, handleUpdate),
    yield takeEvery(ProvincesActionTypes.FETCH_ITEM_REQUEST, handleFetchItem),
  ])
}

export default provincesSaga
